export const storyTellerLoad = (url: string) => {
  return new Promise((resolve, reject) => {
    const head = document.body;
    const script = document.createElement("script");
    script.setAttribute("src", url);
    script.setAttribute("type", "text/javascript");
    if (head !== null) {
      head.appendChild(script);
    }
    script.onload = function() {
      resolve(true);
    };
    script.onerror = function() {
      reject(new Error(`Script loading error: ${url}`));
    };
  });
};
